module.exports = __webpack_public_path__ + "vue-assets/img/special_edition.c611915e.png";